<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.subject-search.title") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn v-if="errorMessage === null" @click="updateEvent" elevation="0" color="primary">
          {{ $t("dialog.subject-search.update") }}
        </v-btn>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-container v-if="errorMessage === null" class="pb-6">
        <v-row>
          <v-col class="my-0 py-0">
            <v-text-field
              v-model="name"
              :label="$t('dialog.subject-search.name')"
              readonly>
              <template v-slot:prepend>
                <v-checkbox
                  v-model="useName"
                  class="text-field-checkbox"
                  hide-details
                />
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="my-0 py-0">
            <v-text-field
              v-model="id"
              :label="$t('dialog.subject-search.id')"
              readonly>
              <template v-slot:prepend>
                <v-checkbox
                  v-model="useId"
                  class="text-field-checkbox"
                  hide-details
                />
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="my-0 py-0">
            <v-text-field
              v-model="vatNumber"
              :label="$t('dialog.subject-search.vat_number')"
              readonly>
              <template v-slot:prepend>
                <v-checkbox
                  v-model="useVatNumber"
                  class="text-field-checkbox"
                  hide-details
                />
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="my-0 py-0">
            <v-text-field
              v-model="address"
              :label="$t('dialog.subject-search.address')"
              readonly>
              <template v-slot:prepend>
                <v-checkbox
                  v-model="useAddress"
                  class="text-field-checkbox"
                  hide-details
                />
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else class="pb-6">
        <v-row justify="center" align="center">
          <v-col class="text-center red--text">
            {{ errorMessage }}
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import utils from "@/utils";

export default {
  name: "SubjectSearchDialog",

  data() {
    return {
      dialog: false,
      errorMessage: null,
      subject: null,

      name: null,
      id: null,
      vatNumber: null,
      address: null,

      useName: true,
      useId: true,
      useVatNumber: true,
      useAddress: true
    };
  },

  methods: {
    async open(countryCode, id) {
      this.countryCode = countryCode;

      const response = await this.$store.dispatch("data/searchSubject", {
        countryCode: countryCode,
        id: id
      });

      if (response !== null) {
        if (response.error === undefined || response.error === null) {
          this.subject = response.data;
          this.name = this.subject.name;
          this.id = this.subject.id;
          this.vatNumber = this.subject.vatNumber;
          if (this.subject.contacts !== null && this.subject.contacts.length > 0) {
            const pa = this.subject.contacts.filter(a => a.type === "address" && a.registered === true);
            if (pa.length > 0)
              this.address = utils.formatLocation(pa[0].contactValue);
          }
          this.useAddress = this.address !== null;

          this.errorMessage = null;
          this.dialog = true;
        } else {
          console.log(response);
          if (response.status === 404)
            this.errorMessage = this.$t("dialog.subject-search.error.not_found");
          else if (response.status === 504)
            this.errorMessage = this.$t("dialog.subject-search.error.gateway_timeout");
          else if (response.status === 400) {
            if (response.message.startsWith("Searching for subjects for the specified country is not supported"))
              this.errorMessage = this.$t("dialog.subject-search.error.country_not_supported");
            else
              this.errorMessage = this.$t("dialog.subject-search.error.invalid_parameter");
          } else
            this.errorMessage = response.message;

          this.dialog = true;
        }
      }
    },

    updateEvent() {
      this.subject.use = {
        name: this.useName,
        id: this.useId,
        vatNumber: this.useVatNumber,
        address: this.useAddress
      };

      this.$emit("update", this.subject);
      this.dialog = false;
    }
  },

  mounted() {
  }
};
</script>

<style lang="sass" scoped>
.text-field-checkbox
  margin-top: -4px
</style>